import { AddressType, IncotermSelector, TCarriageMode } from 'features/BookingFlow'
import { isAddress } from 'features/Directory'
import { FC } from 'react'
import { useController, useFormState, useWatch } from 'react-hook-form'

import { BookingTemplateDetailRow } from './BookingTemplateDetailRow'
import { type BookingTemplateDetailType } from './types/BookingTemplateDetailType'

export const BookingTemplateIncoterm: FC = () => {
  const { field } = useController<BookingTemplateDetailType, 'incoTerm'>({ name: 'incoTerm' })
  const { errors } = useFormState<BookingTemplateDetailType>()
  const modes = useWatch<BookingTemplateDetailType, 'modes'>({ name: 'modes' })
  const bookingParty = useWatch<BookingTemplateDetailType, 'bookingParty'>({ name: 'bookingParty' })
  const type = useWatch<BookingTemplateDetailType, 'type'>({ name: 'type' })
  const origin = useWatch<BookingTemplateDetailType, 'origin'>({ name: 'origin' })
  const destination = useWatch<BookingTemplateDetailType, 'destination'>({ name: 'destination' })

  return (
    <BookingTemplateDetailRow labelTerm="Incoterms" error={!!errors.incoTerm}>
      <IncotermSelector
        selectedIncoTerm={field.value ?? ''}
        handleIncoTermChange={field.onChange}
        fullWidth
        required
        bookingParty={bookingParty}
        originType={isAddress(origin) ? AddressType.Door : AddressType.Port}
        destinationType={isAddress(destination) ? AddressType.Door : AddressType.Port}
        transportType={type}
        transportModes={modes as TCarriageMode[]}
      />
    </BookingTemplateDetailRow>
  )
}
